module.exports = __webpack_public_path__ + "img/showcaseBall.0b10614a.png";